module.exports = __webpack_public_path__ + "static/media/ml-header.fd709793.png";